const SESSION_STORAGE_KEY = {
    LOCAL_SECRET: "localSecret",
    ORCHESTRATOR_CONFIG_EXISTANCE: "orchestratorConfigExistance"
};

export default SESSION_STORAGE_KEY;
